/** ISO 3166-1 alpha-2 values stored in filters; labels match the Students filter panel. */
export const STUDENT_APPLICATION_COUNTRY_OPTIONS = [
	{ value: 'US', label: 'USA' },
	{ value: 'GB', label: 'UK' },
	{ value: 'DE', label: 'Germany' },
	{ value: 'AU', label: 'Australia' },
	{ value: 'NZ', label: 'New Zealand' },
	{ value: 'IE', label: 'Ireland' },
	{ value: 'CA', label: 'Canada' },
	{ value: 'SA', label: 'Saudi Arabia' },
	{ value: 'KR', label: 'South Korea' },
	{ value: 'JP', label: 'Japan' },
	{ value: 'MY', label: 'Malaysia' },
	{ value: 'ID', label: 'Indonesia' },
	{ value: 'SG', label: 'Singapore' },
	{ value: 'VN', label: 'Vietnam' },
	{ value: 'AE', label: 'UAE' },
	{ value: 'IN', label: 'India' },
]

const LABEL_BY_ISO2 = new Map(
	STUDENT_APPLICATION_COUNTRY_OPTIONS.map(o => [
		String(o.value).toUpperCase(),
		o.label,
	]),
)

/** Human label for FiltersSortBar / chips; `code` is the stored ISO2 (e.g. GB → UK). */
export const getStudentApplicationCountryLabel = code => {
	if (code == null || code === '') return ''
	const key = String(code).trim().toUpperCase()
	return LABEL_BY_ISO2.get(key) || String(code)
}
